export default __webpack_public_path__ + "static/media/1049.642b4bcc.png";